import { Descriptions, Flex, QRCode } from "antd";
import styled from "styled-components";

export const StyledContentBody = styled(Flex)`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    width: 100%;
`;

export const StyledModalTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    .title-main {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.primaryTypographyColor};
        line-height: 1.3;
    }

    .title-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: ${({ theme }) => theme.secondaryTypographyColor};
        line-height: 1.4;
    }
`;

export const StyledDescriptions = styled(Descriptions)`
    width: 100%;
    padding: 14px 16px;
    background: ${({ theme }) => theme.itemBackground};
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    border-radius: 12px;

    .ant-descriptions-item {
        padding-bottom: 6px !important;
    }

    .ant-descriptions-item-label {
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.secondaryTypographyColor};
    }

    .ant-descriptions-item-content {
        display: block !important;
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.primaryTypographyColor};
        text-align: right;
    }
`;

export const StyledQRCode = styled(QRCode).attrs(({ theme }) => ({
    bgColor: theme.colors.white,
    color: theme.colors.black,
}))`
    padding: 16px;
`;
